import { render } from "./RoomContent.vue?vue&type=template&id=caffedaa&scoped=true"
import script from "./RoomContent.vue?vue&type=script&lang=js"
export * from "./RoomContent.vue?vue&type=script&lang=js"

import "./RoomContent.vue?vue&type=style&index=0&id=caffedaa&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caffedaa"]])

export default __exports__